import axios from 'axios';

const api = axios.create({
  baseURL: 'https://gfxw040ae6.execute-api.us-east-1.amazonaws.com/api/v1',
});

export default api;